module.exports = __webpack_public_path__ + "img/home-predict-icon-white.ccd985e4.png";